<template lang="pug">
.v-useful-links.useful-links(v-if="data" :id="data?.id")
	.useful-links__title(v-if="data.title") {{data.title}}
	.useful-links__items(v-if="data.items")
		.useful-links__item(v-for="(item, idx) in data.items" :key="idx")
			.useful-links__item-content
				img.useful-links__item-image(v-if="item.image" :src="item.image.src" :alt="item.image.alt")
				.useful-links__item-title {{item.title}}
			.useful-links__item-icon
				v-svg-icon.useful-links__item-icon-arrow(icon="simple-arrow-right-sm")
			a.cover-link.useful-links__link(v-if="item.link" :href="item.link")
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>